// extracted by mini-css-extract-plugin
export var messageSideLeft = "_og-1";
export var messageSideRight = "_og-2";
export var orderLookupBubbleContainer = "_og-0";
export var submitButton = "_og-3";